module.exports = __webpack_public_path__ + "assets/HKNova-Heavy.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Heavy.eot
// module id = 122
// module chunks = 0